import type { DateRange } from 'react-day-picker';
import { formatDateToLocalYYYYMMDD } from '@/lib/formatLocalDate';

/**
 * Appends the Team Insights date picker range to Ask Ellie widget context so
 * navigated chat includes the same window as the charts/metrics.
 */
export function withWidgetDateRangeContext(
  widgetContext: string,
  dateRange: DateRange | undefined
): string {
  if (!dateRange?.from || !dateRange?.to) {
    return widgetContext;
  }
  const from = formatDateToLocalYYYYMMDD(dateRange.from);
  const to = formatDateToLocalYYYYMMDD(dateRange.to);
  const suffix = `Selected date range: ${from} through ${to}.`;
  return `${widgetContext} ${suffix}`;
}
